
/* styles */
require("!!./../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!./../../node_modules/vue-loader/lib/style-rewriter?id=data-v-3b38506c&scoped=true!./../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Loading.vue")

var Component = require("!./../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../node_modules/vue-loader/lib/selector?type=script&index=0!./Loading.vue"),
  /* template */
  require("!!./../../node_modules/vue-loader/lib/template-compiler?id=data-v-3b38506c!./../../node_modules/vue-loader/lib/selector?type=template&index=0!./Loading.vue"),
  /* scopeId */
  "data-v-3b38506c",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Loading.vue
// module id = 832
// module chunks = 2